module.exports = __webpack_public_path__ + "assets/img/img26.b80f0c49.png";